import { React, Component, createRef } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { loginActions } from "../../../../store/user-login.reducer";
import { LOGIN_STATUS as loginStat, LOGIN_USER_ACCESS as userAccess, MOBILE_POLICY_URL as mobilePolicyURL, USER_GUIDE_URL as userGuideURL } from "../../../../utils/constant.utils";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils";
import userimage from "../../../../../../src/img/Avatar.png";
import Icon from "../../../icon";
import ButtonIcon from "../../../button";
//import { GrooveAvatar } from "tfo-groove";
import "./userprofile.component.css";
import Translation from "../../../common/translation/translation.component"
import { Link } from "react-router-dom";
import DateFormat from "./date-format/dateformat";
import { USER_ROLES_ID, EXTERNAL_LINK_TYPES } from "../../../../constants/external-constants";
import { httpGet } from '../../../../utils/api.utils';

class ProfileContainer extends Component {
    constructor(props) {
        super();
        this.state = ({
            showClass: "",
            modalVisible: false,
            userGuideExternalLink: "",
            mobilePolicyExternalLink: ""
        })
        this.wrapperRef = createRef();
    }

    checkIfProfileClickedOutside = (e) => { 
        if (
            this.props.navToggle &&
            this.wrapperRef.current &&
            !this.wrapperRef.current.contains(e.target)            
        ) {
            if(!this.state.modalVisible)
            {
                this.props.onClose();
            }       
        }
    }

    handleModal(value) {
        this.setState({
            modalVisible:value
        });
    }

    componentDidMount() {
        window.addEventListener('mousedown', this.checkIfProfileClickedOutside);
        this.getExternalLink(EXTERNAL_LINK_TYPES.userGuide);
        this.getExternalLink(EXTERNAL_LINK_TYPES.mobilePolicy);
    }

    componentWillUnmount() {
        window.removeEventListener('mousedown', this.checkIfProfileClickedOutside);
    }
    logout = async (e) => {


        e.preventDefault();
        this.props.logout();
    }

    getExternalLink = async (externalLinkId) => {

        var url = 'external/externallink/getExternalLink?externalLinkID=' + externalLinkId;

        var res = await httpGet(url);

        if (res) {
            if (externalLinkId == 1)
            {
                this.setState({
                    userGuideExternalLink: res[0].URL
                });
            }
            else {
                this.setState({
                    mobilePolicyExternalLink: res[0].URL
                });
            }
        }
      
    };

    render() {
        let userModel = JSON.parse(sessionStorage.getItem('User')).Employee;
        let loginStatus = sessionStorage.getItem('logInStatus');
        let dealName = sessionStorage.getItem('DealName');
        let noAccess = validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.PersonalDashboardR, ACCESS_MODULE.PersonalDashboardRE, ACCESS_MODULE.PersonalDashboardRW])
            || validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MyDirectReportsDashboardR, ACCESS_MODULE.MyDirectReportsDashboardRE, ACCESS_MODULE.MyDirectReportsDashboardRW]);

        const isAdmin = sessionStorage.getItem('UserRoleID') == USER_ROLES_ID.admin;

        return (
            <div ref={this.wrapperRef} className="external-userprofile-nav ">
                <div className="userprofile-info">                   
                    <div className="userprofile-header">
                        <div className="right-nav-profile">
                            <img src={userimage} className="cover-profile-image" />                            
                        </div>
                        <h2 className="userprofile-name">{userModel.FirstName + " " + userModel.LastName}</h2>
                        <div className="userprofile-type">{loginStat.external === loginStatus ? userAccess.external : userAccess.internal}</div>
                    </div>
                    <div className="userprofile-data">
                        <Icon
                            customClassName="icon-email"
                            name="envelope"
                            labelValue={userModel.Email}
                            size="15px"
                            containerClass="icon-container"
                        />
                        <Icon
                            customClassName="icon-mobile"
                            name="mobile-button"
                            labelValue={userModel.ContactNumber}
                            size="15px"
                            containerClass="icon-container"
                        />
                        <Icon
                            customClassName="icon-location"
                            name="location-dot"
                            labelValue={userModel.Location.LocationName}
                            size="15px"
                            containerClass="icon-container"
                        />
                    </div>
                </div>
                <div className="horizontal-separator"></div>
                <div className="userprofile-references">
                    <p className="title">
                        <Translation translationKey="reference" />
                    </p>
                    <a href={this.state.userGuideExternalLink} rel="noopener noreferrer" target="_blank">
                        <Icon
                            hidden={noAccess}
                            customClassName="icon-clipboard-list"
                            name="clipboard-list-check"
                            labelValue={<Translation translationKey="user_guide" />}
                            size="20px"
                            containerClass="icon-container"
                            />
                    </a>
                    <a href={this.state.mobilePolicyExternalLink} rel="noopener noreferrer" target="_blank">
                        <Icon
                            hidden={noAccess}
                            customClassName="icon-line"
                            name="file-lines"
                            labelValue={<Translation translationKey="policy_mobile" />}
                            size="19px"
                            containerClass="icon-container"
                        />
                    </a>
                    <Link to={`/external/${dealName}/ReleaseNotes`}>
                        <Icon
                            customClassName="icon-file-code"
                            name="file-code"
                            labelValue="Release Notes"
                            size="19px"
                            containerClass="icon-container"

                        />
                    </Link>
                </div>
                {
                    isAdmin && 
                    <>
                        <div className="horizontal-separator"></div>
                        <DateFormat handleModal={this.handleModal.bind(this)} />
                        <div className="horizontal-separator"></div>
                    </>
                }
                
                {false ? null :
                    <ButtonIcon onClick={(e) => this.logout(e)} iconLeft="sign-out-alt" iconSize="16px" customClassName="userprofile-logout btn-custom-violet-hover-outline" labelClass="logout-label" labelName="Logout" />
                    }
            </div>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
        ...bindActionCreators(loginActions, dispatch)
    }
}

function mapStateToProps(state) {
    return {
        ...state,
        ...state.history
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ProfileContainer);